/*
    This file is part of VBS.
    Copyright (C) 2022  Dylan Loya

    This program is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

/* eslint-disable prettier/prettier */
const BASE_URL = "https://www.googleapis.com/books/v1/volumes?q=";
const BASE_URL_ID = "https://www.googleapis.com/books/v1/volumes/";
const maxResults = "maxResults=";
const orderBy = "orderBy=";
const printType = "printType=";
export const AMAZON_URL = "https://www.amazon.com/s?i=stripbooks&k=";

export async function globalSearch(query) {
    return new Promise((resolve, reject) => {
        fetch(
                BASE_URL +
                query +
                "&" +
                maxResults +
                "40&" +
                orderBy +
                "relevance&" +
                printType +
                "books"
            )
            .then((response) => {
                resolve(response.json());
            })
            .catch((err) => {
                reject(err.message);
            });
    });
}

export async function SearchById(id) {
    return new Promise((resolve, reject) => {
        fetch(BASE_URL_ID + id)
            .then((response) => {
                resolve(response.json());
            })
            .catch((err) => {
                reject(err.message);
            });
    });
}

export const subjectsList = {
    Fiction: [
        "halloween",
        "toussaint",
        "sanguinaire",
        "sanglant",
        "silence",
        "sang",
        "cri",
        "clown",
        "peur",
        "pantin",
        "fantome",
        "revenant",
        "ghost",
        "mystère",
        "affaire",
        "résolu",
        "résolution",
        "enquete",
        "enqueteur",
        "tueur",
        "loupe",
        "gold",
        "surveiller",
        "garde",
        "eloigne",
        "étrange",
        "enquete",
        "police",
        "coupable",
        "criminel",
        "landes",
        "foret",
        "mobile",
        "minuit",
        "soir",
        "histoire",
        "effroit",
        "suspect",
        "L'Inconnu",
        "foret",
        "Faute",
        "preuves",
        "Harry",
        "Potter",
        "Chambre",
        "Secrets",
        "Prisonnier",
        "Remède",
        "mortel",
        "Myron",
        "Bolitar",
        "Collection",
        "Disparue",
        "homme",
        "Maison",
    ],
    Poetry: [
        "femme",
        "homme",
        "amour",
        "demain",
        "aube",
        "souffrir",
        "soupir",
        "ponts",
        "pont",
        "poete",
        "amour",
        "sentiments",
        "déclamation",
        "déclaration",
        "lyrisme",
        "romantisme",
        "vers",
        "rhymes",
        "sentiment",
        "profiter",
        "jouir",
        "temps",
        "fuite",
        "fleur",
        "fleurs",
        "beauté",
        "flamme",
        "feu",
        "reves",
        "soleil",
        "couchant",
        "brisé",
        "spleen",
        "lac",
        "Désastre",
    ],
    Fantasy: [
        "magie",
        "démon",
        "ange",
        "aventure",
        "enqueteur",
        "tueur",
        "loupe",
        "gold",
        "surveiller",
        "garde",
        "eloigne",
        "étrange",
        "enquete",
        "police",
        "coupable",
        "criminel",
        "landes",
        "foret",
        "mobile",
        "minuit",
        "soir",
        "histoire",
        "mystère",
        "effroit",
        "suspect",
    ],
    Romance: [
        "journal",
        "carnet",
        "femme",
        "homme",
        "amour",
        "casanova",
        "amour",
        "étrange",
        "aventure",
        "palpiter",
        "coeur",
        "rouge",
        "fete",
        "réjouissance",
        "saint-valentin",
        "noel",
        "cadeau",
        "offrir",
        "offert",
        "diamant",
        "bague",
        "ile",
        "voyage",
        "vacances",
        "école",
    ],
    Superheroes: [],
    Mystery: [
        "mystère",
        "affaire",
        "résolu",
        "résolution",
        "enquete",
        "homme",
        "passion",
        "femme",
        "foret",
        "animal",
        "loup",
        "flair",
        "police",
        "yeux",
        "cri",
        "appel",
        "tueur",
        "mur",
        "suspect",
        "loupe",
        "gold",
        "surveiller",
        "garde",
        "eloigne",
        "étrange",
        "enquete",
        "police",
        "coupable",
        "criminel",
        "landes",
    ],
    "Juvenile Fiction": [
        "police",
        "tueur",
        "mur",
        "murs",
        "olympe",
        "dieu",
        "dieux",
        "fusée",
        "aventure",
        "ange",
        "démon",
        "magie",
        "mission",
        "code",
        "Alex",
        "Rider",
        "Réveil",
        "Scorpia",
        "Roulette",
        "Russe",
        "Cherub",
        "clan",
        "Aramov",
        "Tome",
        "Never",
        "ange",
        "gardien",
        "dérive",
        "Harry",
        "Potter",
        "prince",
        "Larmes",
        "crocodile",
        "Voleur",
        "foudre",
        "parle",
        "Jumeaux",
        "Fowl",
        "Pointe",
        "Blanche",
        "porte",
        "sang",
    ],
    Adult: ["sexe", "pornographie", "aventure", "prostitution"],
    Crime: [
        "enqueteur",
        "tueur",
        "loupe",
        "gold",
        "surveiller",
        "garde",
        "eloigne",
        "étrange",
        "enquete",
        "police",
        "coupable",
        "criminel",
        "landes",
        "foret",
        "mobile",
        "minuit",
        "soir",
        "histoire",
        "mystère",
        "effroit",
        "suspect",
    ],
    Comics: [],
    Entertainement: [],
    Manga: [],
    Science: [
        "code",
        "mission",
        "ferroviaire",
        "train",
        "aérien",
        "transport",
        "automobile",
        "auto",
        "infini",
        "petit",
        "grand",
        "cuivre",
        "or",
        "banque",
        "argent",
        "astronomie",
        "astronome",
        "space",
        "spatial",
        "poisson",
        "marine",
        "marin",
        "sous-marin",
        "bateau",
        "magma",
        "volcan",
        "éruption",
        "vésuve",
        "stromboli",
        "tempete",
        "ouragant",
        "tornade",
        "hurricain",
        "feu",
        "vent",
        "insecte",
        "fleur",
        "extra-terrestre",
        "vie",
        "aviation",
        "avion",
        "fusée",
        "astre",
        "firmament",
        "découverte",
        "analyse",
        "nature",
        "science",
        "air",
        "mer",
        "loupe",
        "voyage",
        "espace",
        "étoile",
        "monde",
        "terre",
        "planete",
    ],
    Horror: [
        "halloween",
        "toussaint",
        "sanguinaire",
        "sanglant",
        "silence",
        "sang",
        "cri",
        "clown",
        "peur",
        "pantin",
        "fantome",
        "revenant",
        "ghost",
    ],
    Children: [
        "adolescence",
        "comptine",
        "chanson",
        "grand-mère",
        "grand-père",
        "fratrie",
        "soeur",
        "frere",
        "mère",
        "père",
        "mamie",
        "papy",
        "jouer",
        "poupée",
        "vélo",
        "dessin",
        "ballon",
        "foot",
        "arcade",
        "aventure",
        "plage",
        "montagne",
        "rivière",
        "chien",
        "chat",
        "école",
        "maison",
        "animal",
        "trotinette",
    ],
    Biography: [
        "problématique",
        "problème",
        "problèmes",
        "pertinent",
        "pensée",
        "pacte",
        "vérité",
        "serment",
        "sensibilisation",
        "sensible",
        "moi",
        "vie",
        "je",
        "égo",
        "raconter",
        "aventure",
        "analyse",
        "auto",
        "leu00e7on",
        "histoire",
        "témoignage",
    ],
    Guadeloupe: [],
    "Young Adult Fiction": [
        "halloween",
        "toussaint",
        "sanguinaire",
        "sanglant",
        "silence",
        "sang",
        "cri",
        "clown",
        "peur",
        "pantin",
        "fantome",
        "revenant",
        "ghost",
        "mystère",
        "affaire",
        "résolu",
        "résolution",
        "enquete",
        "enqueteur",
        "tueur",
        "loupe",
        "gold",
        "surveiller",
        "garde",
        "eloigne",
        "étrange",
        "enquete",
        "police",
        "coupable",
        "criminel",
        "landes",
        "foret",
        "mobile",
        "minuit",
        "soir",
        "histoire",
        "mystère",
        "effroit",
        "suspect",
        "Survivants",
        "Trafic",
        "Chute",
        "libre",
        "Sang",
        "pour",
    ],
    Humor: [],
};